import Model, { attr, type HasMany, hasMany } from '@ember-data/model';
import { Type } from '@warp-drive/core-types/symbols';
import type CustomTagValue from 'lumen/models/custom-tag-value';

export default class PropertyTagsSubscription extends Model {
  [Type] = 'property-tags/subscription' as const;

  @hasMany('custom-tag-value', { async: false, inverse: null })
  declare customTagValues: HasMany<CustomTagValue>;

  @attr('string') declare name: string;
}
